(() => {
  if (customElements.get('scrolling-images-section')) return;

  class ScrollingImagesSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';

      this.dialog = this.querySelector('[data-lightbox]');
      this.lightboxImage = this.querySelector('[data-lightbox-image]');
      this.instagramLink = this.querySelector(
        '[data-lightbox-instagram]'
      );
      this.instagramLabel = this.querySelector(
        '[data-lightbox-instagram-label]'
      );

      this.previousBodyOverflow = '';

      if (
        !this.dialog ||
        !this.lightboxImage ||
        !this.instagramLink
      ) {
        return;
      }

      this.handleClick = this.handleClick.bind(this);
      this.handleDialogClose =
        this.handleDialogClose.bind(this);

      this.addEventListener('click', this.handleClick);
      this.dialog.addEventListener(
        'close',
        this.handleDialogClose
      );
    }

    disconnectedCallback() {
      this.removeEventListener(
        'click',
        this.handleClick
      );

      if (this.dialog) {
        this.dialog.removeEventListener(
          'close',
          this.handleDialogClose
        );
      }

      this.unlockPage();
    }

    handleClick(event) {
      const closeButton = event.target.closest(
        '[data-lightbox-close]'
      );

      if (closeButton) {
        event.preventDefault();
        this.closeLightbox();
        return;
      }

      const trigger = event.target.closest(
        '[data-lightbox-trigger]'
      );

      if (trigger && this.contains(trigger)) {
        event.preventDefault();
        this.openLightbox(trigger);
        return;
      }

      if (event.target === this.dialog) {
        this.closeLightbox();
      }
    }

    openLightbox(trigger) {
      const imageUrl = trigger.dataset.fullImage;

      if (!imageUrl) return;

      this.lightboxImage.src = imageUrl;
      this.lightboxImage.alt =
        trigger.dataset.imageAlt || '';

      const instagramUrl =
        trigger.dataset.instagramUrl || '';

      const instagramLabel =
        trigger.dataset.instagramLabel ||
        'View on Instagram';

      if (instagramUrl) {
        this.instagramLink.href = instagramUrl;
        this.instagramLink.hidden = false;
        this.instagramLabel.textContent =
          instagramLabel;
      } else {
        this.instagramLink.hidden = true;
        this.instagramLink.removeAttribute('href');
      }

      this.classList.add('is-paused');
      this.lockPage();

      if (
        typeof this.dialog.showModal === 'function'
      ) {
        if (!this.dialog.open) {
          this.dialog.showModal();
        }
      } else {
        this.dialog.setAttribute('open', '');
      }
    }

    closeLightbox() {
      if (!this.dialog.open) return;

      if (typeof this.dialog.close === 'function') {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute('open');
        this.handleDialogClose();
      }
    }

    handleDialogClose() {
      this.classList.remove('is-paused');

      this.unlockPage();

      this.lightboxImage.removeAttribute('src');
      this.lightboxImage.alt = '';

      this.instagramLink.hidden = true;
      this.instagramLink.removeAttribute('href');
    }

    lockPage() {
      this.previousBodyOverflow =
        document.body.style.overflow;

      document.body.style.overflow = 'hidden';
    }

    unlockPage() {
      document.body.style.overflow =
        this.previousBodyOverflow || '';
    }
  }

  customElements.define(
    'scrolling-images-section',
    ScrollingImagesSection
  );
})();